var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R301 - On Route - Traffic Congestion"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60005 10.4V9.6H2.40005V8.8H3.20005V8H2.40005V7.2L3.12005 5.08C3.16005 4.92 3.32005 4.8 3.48005 4.8H5.60005H8.80005C8.64005 4.32 8.24005 4 7.72005 4H3.48005C2.96005 4 2.52005 4.32 2.36005 4.84L1.84005 6.4H1.60005C1.16005 6.4 0.800049 6.76 0.800049 7.2H1.60005V10.8C1.60005 11.04 1.76005 11.2 2.00005 11.2H2.80005C3.04005 11.2 3.20005 11.04 3.20005 10.8V10.4H5.60005ZM6.40005 6.16L6.04005 7.2H3.24005L3.76005 5.6H6.68005C6.56005 5.76 6.48005 5.96 6.40005 6.16ZM14.4 8.8H15.2C15.2 8.36 14.84 8 14.4 8H14.16L13.64 6.44C13.48 5.96 13 5.6 12.52 5.6H8.28005C7.76005 5.6 7.32005 5.92 7.16005 6.44L6.64005 8H6.40005C5.96005 8 5.60005 8.36 5.60005 8.8H6.40005V12.4C6.40005 12.64 6.56005 12.8 6.80005 12.8H7.60005C7.84005 12.8 8.00005 12.64 8.00005 12.4V12H12.8V12.4C12.8 12.64 12.96 12.8 13.2 12.8H14C14.24 12.8 14.4 12.64 14.4 12.4V8.8ZM7.20005 11.2V10.4H8.00005V9.6H7.20005V8.8L7.92005 6.68C7.96005 6.52 8.12005 6.4 8.28005 6.4H12.52C12.68 6.4 12.84 6.52 12.88 6.68L13.6 8.8V9.6H12.8V10.4H13.6V11.2H7.20005ZM8.04005 8.8H12.76L12.24 7.2H8.56005L8.04005 8.8Z",
    fill: "#1FBE88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalType);
export default __webpack_public_path__ + "static/media/personal-type.d2696baf9dbcef26e407d9c981c22f7d.svg";
export { ForwardRef as ReactComponent };